import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-68030d9c"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "audience-footer" };
const _hoisted_2 = {
    key: 1,
    class: "audience-footer__container"
};
const _hoisted_3 = { class: "audience-footer__count" };
import { computed } from 'vue';
import { useStore } from 'vuex';
import AudienceOtoScore from '@/features/Otometro/components/Otometro.vue';
import AudienceFooterCount from './AudienceFooterCount.vue';
import AudienceFooterSteps from './AudienceFooterSteps.vue';
import AudienceFooterButtons from './AudienceFooterButtons.vue';
import AudienceFooterSkeleton from './AudienceFooterSkeleton.vue';
import router from '@/router';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AudienceFooter',
    setup(__props) {
        const store = useStore();
        const loadingCount = computed(() => store.getters['audienceManager/getCount'].loading || store.getters['audienceManager/isLoadingCompositionStage']);
        const isCreationMode = computed(() => !store.getters['audienceManager/isView']);
        const otoScoreIsEnabled = computed(() => store.getters.getEnabledOtoScore && router.currentRoute.value.meta.title !== 'view-audience');
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                (loadingCount.value)
                    ? (_openBlock(), _createBlock(AudienceFooterSkeleton, { key: 0 }))
                    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            (otoScoreIsEnabled.value)
                                ? (_openBlock(), _createBlock(AudienceOtoScore, {
                                    key: 0,
                                    loading: loadingCount.value
                                }, null, 8, ["loading"]))
                                : _createCommentVNode("", true),
                            _createVNode(AudienceFooterCount)
                        ]),
                        (isCreationMode.value)
                            ? (_openBlock(), _createBlock(AudienceFooterSteps, { key: 0 }))
                            : _createCommentVNode("", true),
                        _createVNode(AudienceFooterButtons)
                    ]))
            ]));
        };
    }
});
